import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'

import launchContinueDraftIcon from '@/assets/campaigns/launch/icon-continue-draft.svg'
import launchDashboardGridIcon from '@/assets/campaigns/launch/icon-dashboard-grid.svg'
import launchScreenIcon from '@/assets/campaigns/launch/icon-launch-screen.svg'

import { RECENT_CAMPAIGNS_TABLE } from '../lib/recent-campaigns-table-theme'

export type DashboardIconActionVariant = 'launch' | 'analytics' | 'continue'

const ICON_ACTION_STYLES: Record<DashboardIconActionVariant, { bg: string; src: string }> = {
  launch: { bg: RECENT_CAMPAIGNS_TABLE.actionLaunchBg, src: launchScreenIcon },
  analytics: { bg: RECENT_CAMPAIGNS_TABLE.actionAnalyticsBg, src: launchDashboardGridIcon },
  continue: { bg: RECENT_CAMPAIGNS_TABLE.actionContinueBg, src: launchContinueDraftIcon },
}

function iconActionDimensions(variant: DashboardIconActionVariant): {
  width: number
  height: number
} {
  if (variant === 'launch') return { width: 17, height: 16 }
  if (variant === 'continue') return { width: 11, height: 10 }
  return { width: 15, height: 15 }
}

interface Props {
  variant: DashboardIconActionVariant
  label: string
  testId: string
  onClick: () => void
}

/** Figma `5470:11076` — shared row action icon button for dashboard tables. */
export function DashboardIconAction({ variant, label, testId, onClick }: Readonly<Props>) {
  const style = ICON_ACTION_STYLES[variant]
  const iconSize = iconActionDimensions(variant)

  return (
    <Tooltip title={label}>
      <IconButton
        size="small"
        disableRipple
        aria-label={label}
        data-testid={testId}
        onClick={onClick}
        sx={{
          width: RECENT_CAMPAIGNS_TABLE.actionBtnSize,
          height: RECENT_CAMPAIGNS_TABLE.actionBtnSize,
          borderRadius: RECENT_CAMPAIGNS_TABLE.actionBtnRadius,
          bgcolor: style.bg,
          p: 0,
          flexShrink: 0,
          '&:hover': { bgcolor: style.bg, opacity: 0.92 },
        }}
      >
        <Box
          component="img"
          src={style.src}
          alt=""
          aria-hidden
          sx={{
            width: iconSize.width,
            height: iconSize.height,
            display: 'block',
            objectFit: 'contain',
          }}
        />
      </IconButton>
    </Tooltip>
  )
}

export const dashboardActionsRowSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: RECENT_CAMPAIGNS_TABLE.actionGap,
  justifyContent: 'flex-start',
} as const
